export const SIDEBAR_WIDTHS = {
  COLLAPSED: 80,
  EXPANDED: 270,
};

export const SIDEBAR_MARGINS = {
  COLLAPSED: "ml-[80px]",
  EXPANDED: "ml-[270px]",
};

export const SIDEBAR_STYLES = {
  ACTIVE_BG: "#eff6ff",
  ACTIVE_COLOR: "#2563eb",
  HOVER_BG: "#f3f4f6",
  HOVER_COLOR: "#1f2937",
  TEXT_COLOR: "#374151",
};
